import React, { useState, useEffect } from "react";
import {
  Card,
  Form,
  Button,
  Breadcrumb,
} from "react-bootstrap";
import { Icon } from "@iconify/react";
import UploadImageComponent from "../../components/UploadImageComponent";
import {  WarningSwal } from "../../helpers/alertseet";
import { useNavigate, useParams } from "react-router-dom";
import { get_staff, update_staff } from "../../services/staff.service";
import { useStore } from "../../store/useStore";
import { END_IMAGE } from "../../constants";
import moment from "moment";
import InputField from "../../components/form_item/InputField";
import { Formik } from "formik";
import * as Yup from "yup";
import {
  getProvices,
  getDistrictsByProvinceName,
} from "../../services/masterdata.service";

export default function UpdateStaffPage() {
    // store
  const { token, setIsLoadingDetailPage } = useStore();
  const navigate = useNavigate();
  const { staffId } = useParams();
  // state
    const [provinceList, setProvinceList] = useState([]);
    const [districtList, setDistrictList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [formData, setFormData] = useState({});
  // const [validate, setValidate] = useState({
  //   firstName: false,
  //   lastName: false,
  //   birthday: false,
  //   occupation: false,
  //   phone: false,
  //   gender: false,
  //   userName: false,
  //   password: false,
  //   // role: false,
  //   profileImage: false,
  //   personalID: false,
  //   familyNumber: false,
  //   homeNumber: false,
  //   homeUnit: false,
  //   village: false,
  //   district: false,
  //   province: false,
  // });


  // useEffect
  useEffect(() => {
   if(staffId) {
    getData();
       getProvices().then((res) => {
          setProvinceList(res?.data);
        });
   }
  }, []);

  useEffect(() => {
    if (formData?.province) {
      console.log(formData?.province);
      getDistrictsByProvinceName(formData?.province).then((res) => {
        setDistrictList(res?.data);
      });
    }
  }, [formData?.province]);


    // Validation Schema using Yup
    const validationSchema = Yup.object().shape({
      staffNo: Yup.string()
        .required("ກະລຸນາປ້ອນເລກພະນັກງານ"),
      firstName: Yup.string().required("ກະລຸນາປ້ອນຊື່"),
      lastName: Yup.string().required("ກະລຸນາປ້ອນນາມສະກຸນ"),
      gender: Yup.string().required("ກະລຸນາເລືອກເພດ"),
      phone: Yup.string()
        .required("ກະລຸນາປ້ອນເບີໂທ")
        .matches(/^\d{10}$/, "ເບີໂທຕ້ອງມີ 10 ໂຕເລກ"),
      birthday: Yup.date().required("ກະລຸນາເລືອກວັນເດືອນປີເກີດ"),
      occupation: Yup.string().required("ກະລຸນາປ້ອນອາຊີບ"),
      homeUnit: Yup.string().required("ກະລຸນາປ້ອນໜ່ວຍ"),
      homeNumber: Yup.string().required("ກະລຸນາປ້ອນເຮືອນເລກທີ"),
      province: Yup.string().required("ກະລຸນາເລືອກແຂວງ"),
      district: Yup.string().required("ກະລຸນາເລືອກເມືອງ"),
      village: Yup.string().required("ກະລຸນາປ້ອນບ້ານ"),
    });
  
    // Initial Values
    const initialValues = {
      branchId: formData?.branchId,
      staffNo: formData?.staffNo || "",
      firstName:formData?.firstName || "",
      lastName: formData?.lastName|| "",
      gender: formData?.gender||"",
      phone: formData?.phone||"",
      birthday:formData?.birthday|| "",
      occupation: formData?.occupation || "",
      homeUnit: formData?.homeUnit ||"",
      homeNumber: formData?.homeNumber ||"",
      province: formData?.province ||"",
      district: formData?.district ||"",
      village: formData?.village ||"",
      userName: "",
      password: "",
    };
  // function

  const getData = async () => {
    try {
      setIsLoading(true);
      setIsLoadingDetailPage(true);
      const data = await get_staff(staffId, token);
      if (data?.error) throw new Error(data?.message);
      let staff = data?.data;
      staff.birthday = moment(staff.birthday).format("YYYY-MM-DD");
      delete staff.password;
      setFormData(staff);
      setIsLoading(false);
      setIsLoadingDetailPage(false);
    } catch (err) {
      console.error("error", err);
      setIsLoading(false);
      setIsLoadingDetailPage(false);
    }
  };

  const handleUpdateStaff = async (values) => {
    try {
      if (isLoading) {
        WarningSwal("ກະລຸນາລໍຖ້າ");
        return;
      }
      setIsLoading(true);
      const newData = {
        ...values,
        profileImage: formData?.profileImage || "",
      }
      const data = await update_staff(staffId, newData, token);
      if (data?.error) {
        throw new Error(data?.message);
      }
      setIsLoading(false);
      navigate("/staff", { replace: true });
    } catch (err) {
      console.error(err);
      setIsLoading(false);
    }
  };
  return (
    <div>
      <Breadcrumb>
        <Breadcrumb.Item onClick={() => navigate("/staff", { replace: true })}>
          ຈັດການພະນັກງານ
        </Breadcrumb.Item>
        <Breadcrumb.Item active>ແກ້ໄຂບັນຊີ</Breadcrumb.Item>
      </Breadcrumb>
      {
        isLoading ? (
         <p>Loading....</p>
        ) : (
          <Card
          style={{
            padding: "20px 20px",
            minHeight: "80dvh",
            position: "relative",
            paddingBottom: 150,
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "auto 1fr",
              gap: 20,
              gridGap: 20,
            }}
          >
            <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
              <h2>ຮູບພາບ</h2>
              <div>
                <UploadImageComponent
                  src={
                    formData?.profileImage
                      ? END_IMAGE + formData?.profileImage
                      : ""
                  }
                  style={{ width: 160, height: 160, objectFit: "cover" }}
                  onChange={(image) =>
                    setFormData((prev) => ({
                      ...prev,
                      profileImage: image,
                    }))
                  }
                />
              </div>
            </div>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values) => {
                  console.log("updatevalues", values);
                  handleUpdateStaff(values);
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <div
                      style={{ display: "flex", flexDirection: "column", gap: 20 }}
                    >
                      <h2>ຂໍ້ມູນສ່ວນໂຕ</h2>
                      <div>
                        <Form.Label>ເລກພະນັກງານ</Form.Label>
                        <InputField
                          icon={
                            <Icon
                              icon="tabler:id"
                              style={{ width: 24, height: 24 }}
                            />
                          }
                          maxLength={4}
                          placeholder="0XXX"
                          name="staffNo"
                          errors={errors.staffNo}
                          touched={touched.staffNo}
                          value={values.staffNo}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </div>
                      <div>
                        <Form.Label>ຊື່</Form.Label>
                        <InputField
                          icon={
                            <Icon
                              icon="material-symbols:person-outline"
                              style={{ width: 24, height: 24 }}
                            />
                          }
                          placeholder="ກະລຸນາປ້ອນຊື່"
                          name="firstName"
                          value={values.firstName}
                          touched={touched.firstName}
                          errors={errors.firstName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </div>
                      <div>
                        <Form.Label>ນາມສະກຸນ</Form.Label>
                        <InputField
                          icon={
                            <Icon
                              icon="material-symbols:person-outline"
                              style={{ width: 24, height: 24 }}
                            />
                          }
                          placeholder="ກະລຸນາປ້ອນນາມສະກຸນ"
                          name="lastName"
                          value={values.lastName}
                          touched={touched.lastName}
                          errors={errors.lastName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </div>
                      <Form.Group>
                        <Form.Label>ເພດ</Form.Label>
                        <div style={{ display: "flex", gap: 20 }}>
                          <Form.Check
                            type="radio"
                            label={`ຊາຍ`}
                            name="gender"
                            id="radio-sex-m"
                            isInvalid={touched?.gender && errors?.gender}
                            value="MALE"
                            checked={values?.gender === "MALE"}
                            onChange={handleChange}
                          />
                          <Form.Check
                            type="radio"
                            label={`ຍິງ`}
                            name="gender"
                            id="radio-sex-f"
                            isInvalid={touched?.gender && errors?.gender}
                            value="FEMALE"
                            checked={values?.gender === "FEMALE"}
                            onChange={handleChange}
                          />
                        </div>
                        {errors.gender && touched.gender && (
                          <p style={{ color: "#FF0000" }}>{errors.gender}</p>
                        )}
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>ເບີໂທ</Form.Label>
                        <InputField
                          icon={
                            <Icon
                              icon="uil:phone-alt"
                              style={{ width: 24, height: 24 }}
                            />
                          }
                          placeholder="20XXXXXXXX"
                          name="phone"
                          type={"tel"}
                          value={values.phone}
                          touched={touched.phone}
                          errors={errors.phone}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </Form.Group>
                      <div>
                        <Form.Label>ວັນ/ເດືອນ/ປີ ເກີດ</Form.Label>
                        <InputField
                          icon={
                            <Icon
                              icon="uil:user-plus"
                              style={{ width: 24, height: 24 }}
                            />
                          }
                          type="date"
                          name="birthday"
                          value={values.birthday}
                          touched={touched.birthday}
                          errors={errors.birthday}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </div>
                      <Form.Group>
                        <Form.Label>ອາຊີບ</Form.Label>
                        <InputField
                          icon={
                            <Icon
                              icon="uil:suitcase-alt"
                              style={{ width: 24, height: 24 }}
                            />
                          }
                          placeholder="ປ້ອນອາຊີບ"
                          name="occupation"
                          value={values.occupation}
                          touched={touched.occupation}
                          errors={errors.occupation}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>ໜ່ວຍ</Form.Label>
                        <InputField
                          icon={
                            <Icon
                              icon="material-symbols:cottage-outline-rounded"
                              style={{ width: 24, height: 24 }}
                            />
                          }
                          placeholder="ປ້ອນໜ່ວຍ"
                          name="homeUnit"
                          value={values.homeUnit}
                          touched={touched.homeUnit}
                          errors={errors.homeUnit}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>ເຮືອນເລກທີ</Form.Label>
                        <InputField
                          icon={
                            <Icon
                              icon="material-symbols:cottage-outline-rounded"
                              style={{ width: 24, height: 24 }}
                            />
                          }
                          placeholder="ປ້ອນເຮືອນເລກທີ"
                          name="homeNumber"
                          value={values.homeNumber}
                          touched={touched.homeNumber}
                          errors={errors.homeNumber}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>ແຂວງ</Form.Label>
                        <Form.Select
                          name="province"
                          isInvalid={touched?.province && errors?.province}
                          value={values.province}
                          onChange={(e) => {
                            handleChange(e);
                            setFormData((prev) => ({ ...prev, province: e.target.value }));
                          }}
                        >
                          <option>ເລືອກເເຂວງ</option>
                          {provinceList?.map((item) => (
                            <option value={item.provinceName} key={item._id}>
                              {item.provinceName}
                            </option>
                          ))}
                        </Form.Select>
                        {errors.province && touched.province && (
                          <p style={{ color: "#FF0000" }}>{errors.province}</p>
                        )}
                      </Form.Group>
    
                      {/* District */}
                      <Form.Group>
                        <Form.Label>ເມືອງ</Form.Label>
                        <Form.Select
                          name="district"
                          value={values.district}
                          onChange={handleChange}
                          isInvalid={touched?.district && errors?.district}
                        >
                          <option>ເລືອກເເມືອງ</option>
                          {districtList?.map((item) => (
                            <option value={item.districtName} key={item._id}>
                              {item.districtName}
                            </option>
                          ))}
                        </Form.Select>
                        {errors.district && touched.district && (
                          <p style={{ color: "#FF0000" }}>{errors.district}</p>
                        )}
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>ບ້ານ</Form.Label>
                        <InputField
                          icon={
                            <Icon
                              icon="uil:location-point"
                              style={{ width: 24, height: 24 }}
                            />
                          }
                          placeholder="ກະລຸນາປ້ອນຂໍ້ມູນ..."
                          name="village"
                          value={values.village}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.village}
                          errors={errors.village}
                        />
                      </Form.Group>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 20,
                        }}
                      >
                        <h2>ຂໍ້ມູນບັນຊີເຂົ້າໃຊ້ລະບົບ</h2>
                        <Form.Group>
                          <Form.Label>ເລກໄອດີຜູ້ໃຊ້</Form.Label>
                          <InputField
                            icon={
                              <Icon
                                icon="material-symbols:person-outline"
                                style={{ width: 24, height: 24 }}
                              />
                            }
                            placeholder="ປ້ອນເລກໄອດີຜູ້ໃຊ້"
                            name="userName"
                            value={values.userName}
                            touched={touched.userName}
                            errors={errors.userName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </Form.Group>
                        <Form.Group>
                          <Form.Label>ລະຫັດຜ່ານ</Form.Label>
                          <InputField
                            icon={
                              <Icon
                                icon="uil:lock"
                                style={{ width: 24, height: 24 }}
                              />
                            }
                            placeholder="ປ້ອນລະຫັດຜ່ານ"
                            name="password"
                            value={values.password}
                            touched={touched.password}
                            errors={errors.password}
                            handleBlur={handleBlur}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
          
                        </Form.Group>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          gap: 20,
                          justifyContent: "flex-end",
                        }}
                      >
                        <Button
                          variant="outline-primary"
                          size="md"
                          disabled={isLoading}
                          onClick={() => navigate("/staff", { replace: true })}
                        >
                          ຍົກເລີກ
                        </Button>
                        <Button disabled={isLoading} type="submit" size="md">
                           {isLoading ? "ກໍາລັງບັນທຶກ" : "ບັນທຶກ"}
                        </Button>
                      </div>
                    </div>
                  </form>
                )}
              </Formik>
          </div>
        </Card>
        )
      }
    </div>
  );
}
